import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as AddFileImg } from '../../../img/ico-prefix-add-file.svg';
import { ReactComponent as UrlImg } from '../../../img/ico-prefix-url.svg';

import { useTranslation } from "react-i18next";
import { CustomImgBtn } from "../../base/CustomImgBtn";
import { CustomCircleCheckBox, CustomSquareCheckBox } from "../../base/CustomCheckBox";
import CustomText from "components/base/CustomText";

interface RouterAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

RouterAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function RouterAdd(props:RouterAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    const [routerName, setRouterName] = useState("");
    const [routerDescription, setRouterDescription] = useState("");

    const [networkList, setNetworkList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [networkId, setNetworkId] = useState("");
    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [projectId, setProjectId] = useState("");

    const [routerNameWarnYn, setRouterNameWarnYn] = useState(false);
    
    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadProjectList();
            loadNetworkList();
        }
    }, [stepIndex])


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkRouterData();
                if(successYn) {
                    setExecuteAddYn(true);
                } else {
                    executeResult({successYn: false}, false, '');;
                }
            }
            
        }
    }, [props.clickedConfirmYn]);


    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setProjectList(response.data.items.map((data, index) => {
                    return { value: data.project_id, label: data.project_name };
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function loadNetworkList() {
        requests.get(PLATFORM_URL.VM_NETWORK, {size: 9999})
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setNetworkList(response.data.items.filter((data)=>
                    data.external_yn === true
                ).map((data, index) => {
                    return { value: data.network_id, label: data.network_name };
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    useEffect(() => {
        setNetworkId(networkList[0].value);
    }, [networkList]);

    useEffect(() => {
        if(executeAddYn) {
            executeAddRouter();
        }
    }, [executeAddYn]);

    function checkRouterData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setRouterNameWarnYn(false);
        
        let message = "";
        let error = false;
        if(!routerName || projectId === "" || networkId === "") {
            message = t("MESSAGE_ROUTER_INFO_ENTER_ERROR_MESSAGE");
            if(!routerName) {
                setRouterNameWarnYn(true);
            }
            
            error = true;
        }
        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }
    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function executeAddRouter() {
        const addPackageData = {
            router: {
                router_name: routerName,
                router_description: routerDescription,
                ha_yn: true,
                up_yn: true,
                external_gateway_snat_yn:true
              },
              network: {
                network_id: networkId
              },
              project: {
                project_id : projectId
              }
        };

        requests.post(PLATFORM_URL.ROUTER, addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_ROUTER_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_ROUTER_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("ROUTER_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("ROUTER_NAME_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={routerName} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setRouterName} 
                                warnYn={routerNameWarnYn} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowTopAlignContainer}>
                            <Text style={style.columnText}>
                                {t("ROUTER_DESCRIPTION_TEXT")}
                            </Text>
                            <TextArea 
                                key={3} 
                                width={570} height={100} 
                                value={routerDescription} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setRouterDescription} 
                                warnYn={false}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("ROUTER_TABLE_COLUMN_ROUTER_NETWORK")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={10}
                                value={networkId}
                                width={300} height={36} 
                                items={networkList}
                                setValue={setNetworkId} 
                                disable={false}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <CustomText text={t("PROJECT_INFO_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={11} 
                                width={300} height={36} 
                                items={projectList}
                                setValue={setProjectId} 
                                disable={false}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                    </View>
                </View> 
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}